import { Component, Optional } from '@angular/core';
import { ItemWithSelection } from '@app/shared/models/item-with-selection';
import { OpenArhivWindowActionUtil } from '@app/shared/util/open-arhiv-window-util';
import {
  ActionWindowParams,
  DEFAULT_ITEM_VIEW,
  EMPTY_ACTION_RESULT,
  Item,
  ItemActionResult,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ViewResult,
  ViewState,
  ViewWindow,
  WindowRegistry
} from '@ntap/core';
import { PrimeNGButtonNewItemViewActionComponent } from '@ntap/primeng';
import { filter, first, map, mergeMap, Observable, tap } from 'rxjs';

@Component({ template: '' })
export class OpenDialogItemsListActionComponent extends PrimeNGButtonNewItemViewActionComponent {
  someSelectedUIzlucivanju: boolean;
  tooltip: string | null = null;

  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    protected listViewProvider: ListViewProviderDirective<ListView>
  ) {
    super(notificationService, windowRegistry, window, listViewProvider);
  }

  protected override doExecuteWithItem(): Observable<ItemActionResult> {
    return this.listViewProvider.selectedItems$.pipe(
      first(),
      mergeMap((selectedItems) => {
        const viewState = this.getInitialState(selectedItems);

        return this.doOpenWindow(viewState).pipe(
          filter((viewResult) => this.acceptResult(viewResult)),
          tap(() => this.log('result ACCEPTED')),
          map(
            (viewResult) =>
              new ItemActionResult(EMPTY_ACTION_RESULT, viewResult.viewData[0])
          )
        );
      })
    );
  }

  protected getInitialState(
    selectedItems: Item[]
  ): ViewState & ItemWithSelection {
    return {
      $selected: selectedItems,
      $listName: '',
      $selectedAll: false,
      $filterCriteria: [],
      $parentId: 0,
      $parent: null
    };
  }

  private doOpenWindow(viewState: ViewState): Observable<ViewResult> {
    return OpenArhivWindowActionUtil.open(
      this.getActionWindowParams(),
      viewState
    );
  }

  protected override getActionWindowParams(): ActionWindowParams {
    this.doSetDefaultActionViewName();
    const actionWindowParams = OpenArhivWindowActionUtil.createParams(
      this.action,
      this.windowRegistry,
      this.getWindowTarget()
    );
    return actionWindowParams;
  }

  private doSetDefaultActionViewName() {
    if (!this.action.$openViewName) {
      this.action.$openViewName = DEFAULT_ITEM_VIEW;
    }
  }
}
